  
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { Event, PaginatedResponse, Params } from "../../types/Types";

export function useFindEvents({
  enabled = true,
  pageSize = 10,
  page = 1,
  searchTerm,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ['events', { pageSize, page, searchTerm }],
    queryFn: async () => {
      let url = getAPIURL(`/Event/All?pageNumber=${page}&pageSize=${pageSize}`);
      
      if (searchTerm) {
        url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
      }
      
      return axiosInstance<PaginatedResponse<Event>>(url).then((res) => res.data);
    },
  });
}